import React, { CSSProperties } from "react";
import "./NavigationLink.scss";
import Logo from "../../../resources/images/logo.svg";

export type NavigationLinkProps = {
    label: string;
    icon: string;
    href?: string;
    children?: any[];
    tabindex?: number;
};

const NavigationLink = React.forwardRef((props: NavigationLinkProps) => {
    const isGroupMenu = props.children && props.children.length > 0;
    const [isOpen, setOpen] = React.useState(false);

    React.useEffect(() => {
        if (isOpen) {
            window.setTimeout(() => {
                window.addEventListener("click", closeMenu, false);
            }, 100);
        } else {
            window.removeEventListener("click", closeMenu, false);
        }
        return () => {
            window.removeEventListener("click", closeMenu, false);
        };
    }, [isOpen]);

    const closeMenu = (e: any) => {
        const groupId = e.target.getAttribute("data-link");
        if (groupId === "group") {
            return;
        }

        setOpen(false);
    };

    const handleOpenCloseClick = () => {
        setOpen(!isOpen);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (e.code === "Enter" || e.code === "NumpadEnter") {
            handleOpenCloseClick();
        }
    };

    return (
        <div className={"navigation-menu-wrapper"}>
            <div className={"navigation-link " + (isOpen ? "open" : "")}>
                <a href={props.href} onClick={isGroupMenu ? handleOpenCloseClick : undefined} onKeyDown={handleKeyDown} tabIndex={0}>
                    <i className={props.icon} /> {props.label}
                </a>
            </div>

            {isOpen && (
                <div className="menu-datalayer">
                    <div className="mobile-menu-header">
                        <a href="/">
                            <img className={"eos-mobile-logo"} src={Logo} alt={"EOS"} />
                        </a>
                        <i className="menu-close icon-cancel" />
                    </div>

                    {props.children}
                </div>
            )}
        </div>
    );
});

export type LinkItemProps = {
    href?: string;
    label: string;
    icon?: string;
    subItems?: LinkItemProps[];
    level?: number;
    dataIndex?: number;
    onClick?: any;
    isMobileOnly?: boolean;
    show: boolean;
};

export const LinkItem = function (props: LinkItemProps) {
    const isGroupMenuItem = props.subItems && props.subItems.length > 0;
    const [isOpen, setOpen] = React.useState(false);
    const paddingLevel = props.level ? props.level * 40 + "px" : undefined;
    const borderLevel = isGroupMenuItem && isOpen ? "solid 1px white" : undefined;

    const handleClick = (e: any) => {
        e.preventDefault();
        if (isGroupMenuItem) {
            setOpen(!isOpen);
        } else {
            props.onClick();
        }
    };

    if (props.show) {
        return (
            <div className={"link-wrapper" + (props.isMobileOnly ? " mobile-link" : "")}>
                <a href={props.href} onClick={isGroupMenuItem || props.onClick ? handleClick : undefined} tabIndex={0}>
                    <div style={{ paddingLeft: paddingLevel, borderBottom: borderLevel }} className="link-item">
                        <i className={"link-icon " + props.icon} />

                        <span className="link-label" data-link={isGroupMenuItem ? "group" : "link"}>
                            {props.label}
                            {isGroupMenuItem && <i className={isOpen ? "icon-arrow-up" : "icon-arrow-down"} data-link={isGroupMenuItem ? "group" : "link"} />}
                        </span>
                    </div>
                </a>

                {isOpen && props.subItems?.map((item: LinkItemProps) => <LinkItem label={item.label} level={1} onClick={item.onClick} href={props.href} show={item.show} />)}
            </div>
        );
    } else {
        return <></>;
    }
};

export default NavigationLink;
